import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "app-dialog-invitaciones",
    templateUrl: "./dialog-invitaciones.component.html",
    styleUrls: ["./dialog-invitaciones.component.scss"],
})
export class DialogInvitacionesComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DialogInvitacionesComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            idOOTT: number;
            puedeAsignar: boolean;
        }
    ) {}

    ngOnInit(): void {}
}
